// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"ab69c935","707":"381f8b96","729":"6e77c291"}[chunkId] + ".js";
};